import {type FC, useEffect} from 'react';
import callApi from '../../apis/callApi.ts';
import useCenterStore from '../../store/useCenterStore.ts';
import {PageWrapper, Wrapper} from './types/VideoCallPage.styled.ts';
import {SlideContainer} from '../message/types/MessagePage.styled.ts';
import useVideoCallStore from '../../store/useVideoCallStore.ts';
import VideoCallScreen from './component/VideoCallScreen.tsx';
import {FocusContext, setFocus, useFocusable} from '@noriginmedia/norigin-spatial-navigation';
import BoroughWrapper from './component/BoroughWrapper.tsx';
import VideoCallCenterList from './component/VideoCallCenterList.tsx';
import useGlobalStore from '../../store/useGlobalStore.ts';

const VideoCallPage: FC = () => {
    const {centerInfo} = useCenterStore();
    const {boroughs, setBoroughs, currentPage, isCalling} = useVideoCallStore();
    const deviceID = localStorage.getItem('deviceID');

    const fetchData = async () => {
        const {data} = await callApi().get(`/center/senior-center/?device_id=${centerInfo?.center_id}`);
        const sortedBoroughs = data.boroughs.sort((a: any, b: any) => {
            if (a.name === '기타') return 1;
            if (b.name === '기타') return -1;
            return 0;
        });
        const allIndex = sortedBoroughs.findIndex((b: any) => b.name === 'all');
        if (allIndex !== -1) {
            const allItem = sortedBoroughs.splice(allIndex, 1)[0];
            sortedBoroughs.splice(4, 0, allItem);
        }
        const etcIndex = sortedBoroughs.findIndex((b: any) => b.name === '기타');
        if (etcIndex !== -1) {
            const etcItem = sortedBoroughs.splice(etcIndex, 1)[0];
        }
        console.log(sortedBoroughs);
        const boroughsWithSortedCenters = sortedBoroughs.map((borough: any) => ({
            ...borough,
            centers: [...borough.centers].sort((a: any, b: any) => a.centerid.localeCompare(b.centerid)),
        }));
        setBoroughs(boroughsWithSortedCenters);
    };

    // const fetchData = async () => {
    //     if (!centerInfo) {
    //         await getCenterInfo(deviceID!);
    //     } else {
    //         // const {data} = await callApi().get(`/jitsi/senior-center/?device_id=${centerInfo?.center_id}`);
    //         const {data} = await callApi().get(`/center/senior-center/?device_id=${centerInfo?.center_id}`);
    //         const sortedBoroughs = data.boroughs.sort((a: any, b: any) => {
    //             if (a.name === '기타') return 1;
    //             if (b.name === '기타') return -1;
    //             return 0;
    //         });
    //         console.log('도래도래`; ', sortedBoroughs);
    //         const boroughsWithSortedCenters = sortedBoroughs.map((borough: any) => ({
    //             ...borough,
    //             centers: [...borough.centers].sort((a: any, b: any) =>
    //                 a.centerid.localeCompare(b.centerid)
    //             )
    //         }));
    //         setBoroughs(boroughsWithSortedCenters);
    //     }
    // }

    useEffect(() => {
        if (deviceID) {
            fetchData();
        }
    }, [centerInfo]);

    useEffect(() => {
        setFocus('videoCall');
    }, []);

    const {
        ref: videoCallRef,
        focusKey: videoCallFocusKey,
        focusSelf: videoCallFocusSelf,
    } = useFocusable({
        focusKey: 'video-call-page',
        preferredChildFocusKey: '2-게양구',
        saveLastFocusedChild: true,
        trackChildren: true,
        isFocusBoundary: true,
    });

    const {stack} = useGlobalStore();
    useEffect(() => {
        // if (boroughs.length > 0) {
        //     videoCallFocusSelf();
        if (stack.length > 0) setFocus(`${stack[stack.length - 1].id}_CLOSE_BUTTON`);
        // }
    }, [boroughs, videoCallFocusSelf]);

    const {ref: videoCallDetailRef, focusKey: videoCallDetailFocusKey} = useFocusable({
        focusKey: 'video-call-detail-page',
        preferredChildFocusKey: 'back-to-list',
        saveLastFocusedChild: true,
        trackChildren: true,
        isFocusBoundary: true,
    });

    return (
        <SlideContainer $currentpage={currentPage}>
            <FocusContext.Provider value={videoCallFocusKey}>
                <Wrapper ref={videoCallRef}>
                    {boroughs.map((b) => (
                        <BoroughWrapper key={b.id} item={b} />
                    ))}
                </Wrapper>
            </FocusContext.Provider>
            <FocusContext.Provider value={videoCallDetailFocusKey}>
                <PageWrapper ref={videoCallDetailRef}>
                    <VideoCallCenterList />
                </PageWrapper>
            </FocusContext.Provider>
            {isCalling && <VideoCallScreen />}
        </SlideContainer>
    );
};

export default VideoCallPage;
